import { Schema } from "joi";
import { InputHTMLAttributes, ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import { InputErrorMessage } from "./InputErrorMessage";

export interface CheckboxInputProps extends InputHTMLAttributes<HTMLInputElement> {
    name: string;
    label?: ReactNode;
    rules?: { required?: boolean; [x: string]: any };
    schema?: Schema;
    omit?: true;
    showNoError?: true;
}

export const CheckboxInput = ({
                                  name,
                                  schema,
                                  className = "",
                                  label,
                                  rules = {},
                                  omit,
                                  showNoError,
                                  ...props
                              }: CheckboxInputProps) => {
    const { register } = useFormContext();

    return (
        <div className={"form-group form-check" + (className ? " " + className : "")}>
            <input {...register(name, rules)} className="form-check-input" type="checkbox" name={name} {...props} />
            <label className="form-check-label">
                {label} {rules.required ? "*" : ""}
            </label>
            {!showNoError && <InputErrorMessage name={name} />}
        </div>
    );
};
